import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTwo = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M12.546 18.582C12.8633 18.33 13.008 18.2133 12.98 18.232C13.8947 17.476 14.6133 16.8553 15.136 16.37C15.668 15.8847 16.116 15.376 16.48 14.844C16.844 14.312 17.026 13.794 17.026 13.29C17.026 12.9073 16.9373 12.6087 16.76 12.394C16.5827 12.1793 16.3167 12.072 15.962 12.072C15.6073 12.072 15.3273 12.2073 15.122 12.478C14.926 12.7393 14.828 13.1127 14.828 13.598H12.518C12.5367 12.8047 12.7047 12.142 13.022 11.61C13.3487 11.078 13.7733 10.686 14.296 10.434C14.828 10.182 15.416 10.056 16.06 10.056C17.1707 10.056 18.006 10.3407 18.566 10.91C19.1353 11.4793 19.42 12.2213 19.42 13.136C19.42 14.1347 19.0793 15.0633 18.398 15.922C17.7167 16.7713 16.8487 17.602 15.794 18.414H19.574V20.36H12.546V18.582Z" })
});
export { SvgTwo as ReactComponent };
